export default "__VITE_ASSET__2cHHqezr__"